import { LoginPage } from '#/views/login'
import { getLayout, LayoutWithoutSideMenu } from '#/widgets/layouts'

LoginPage.getLayout = getLayout(LayoutWithoutSideMenu, { titlePage: 'Авторизация' })

export default LoginPage
